export default __webpack_public_path__ + "static/media/3123.277688e4.jpg";